import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import {
  RequirementDefinitionDataSourceSettingsItem,
  useQueryRequirementDefinitionsSettings
} from "./useQueryRequirementDefinitionsSettings";
import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import { useQueryRequirementDefinition } from "./useQueryRequirementDefinition";

export const QUERY_EXTENDED_REQUIREMENT_DEFINITION =
  "QUERY_EXTENDED_REQUIREMENT_DEFINITION";

export interface ExtendedRequirementDefinition
  extends IRequirementDefinitionResponse {
  dataSource?: RequirementDefinitionDataSourceSettingsItem & {
    contextType?: SharedFileRequestContextType;
  };
}

export const useQueryExtendedRequirementDefinition = (
  requirementDefinitionId: string
) => {
  const queryRequirement = useQueryRequirementDefinition(
    requirementDefinitionId
  );
  const querySettings = useQueryRequirementDefinitionsSettings({
    enabled: queryRequirement.isSuccess,
    requirementDefinitions: queryRequirement.data
      ? [queryRequirement.data]
      : [],
    fetch: "all"
  });

  return useWSQuery<ExtendedRequirementDefinition, WSServiceError>(
    [QUERY_EXTENDED_REQUIREMENT_DEFINITION, requirementDefinitionId],
    () => {
      const requirement = queryRequirement.data!;

      const extendedRequirement = {
        ...requirement,
        dataSource: querySettings.data?.[requirement.dataSourceId!]
      };

      return Promise.resolve(extendedRequirement);
    },
    {
      enabled: queryRequirement.isSuccess && querySettings.isFetched
    }
  );
};
